export default __webpack_public_path__ + "assets/img/id_now_en-IE.png";